import { AlertTriangle, HeartPulse, Hospital, Users } from "lucide-react";

const outcomes = [
  { icon: Hospital, text: "Reduce avoidable hospital visits" },
  { icon: HeartPulse, text: "Provide clinical oversight at home" },
  { icon: Users, text: "Support safe hospital discharge" },
  { icon: AlertTriangle, text: "Help clients stay stable long-term" },
];

export const ProblemSolved = () => {
  return (
    <section
      id="about"
      data-testid="problem-section"
      className="relative py-20 sm:py-28 bg-[var(--ew-bg-2)]"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <p className="eyebrow">About Everwell</p>
            <h2 className="font-heading font-medium mt-3 text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.08] text-[var(--ew-text)]">
              Bridging the gap between community supports and clinical care.
            </h2>
            <p className="mt-6 text-base sm:text-lg text-[var(--ew-text-2)] leading-relaxed">
              Everwell Community Nursing Pty Ltd is a locally operated,
              Registered Nurse-led service in Canberra. We provide direct
              community nursing to individuals and flexible subcontracted
              nursing to healthcare, aged care, rehabilitation and community
              care organisations across Canberra and nearby NSW.
            </p>
            <p className="mt-4 text-base sm:text-lg text-[var(--ew-accent)] font-medium">
              Where clinically appropriate and within the Registered Nurse&apos;s
              scope of practice.
            </p>
          </div>

          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-5">
              {outcomes.map((o, i) => (
                <div
                  key={i}
                  data-testid={`outcome-${i}`}
                  className="ew-card p-6 sm:p-7 flex items-start gap-4"
                >
                  <div className="icon-badge shrink-0">
                    <o.icon className="h-5 w-5" strokeWidth={1.75} />
                  </div>
                  <div>
                    <p className="font-heading text-lg font-medium text-[var(--ew-text)] leading-snug">
                      {o.text}
                    </p>
                    <div className="mt-3 h-1 w-10 rounded-full bg-[var(--ew-sage)]/50" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSolved;
